import { render } from "./ImageInContainer.vue?vue&type=template&id=c55f793c&scoped=true&lang=html"
import script from "./ImageInContainer.vue?vue&type=script&lang=js"
export * from "./ImageInContainer.vue?vue&type=script&lang=js"

import "./ImageInContainer.vue?vue&type=style&index=0&id=c55f793c&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c55f793c"]])

export default __exports__